document.addEventListener('DOMContentLoaded', function() {
  // 1) Selectores
  const thumbButtons = Array.from(document.querySelectorAll('.video-thumb'));
  const previewVideos = thumbButtons.map(btn => btn.querySelector('video'));
  const modal = document.getElementById('VideoModal');
  const modalVideo = document.getElementById('ModalVideo');
  const closeBtn = modal.querySelector('.video-modal-close');
  if (!thumbButtons.length || !modal) return;

  // 2) Autoplay de miniaturas
  let current = 0;
  let previewTimer;

  function playPreview() {
  // Stop all videos
  previewVideos.forEach(v => {
    v.pause();
    v.currentTime = 0;
  });

  // Play the current video
  const vid = previewVideos[current];
  vid.muted = true;
  vid.setAttribute('playsinline', true); // Prevent fullscreen on mobile
  vid.play();

  // Schedule next preview
  previewTimer = setTimeout(() => {
    current = (current + 1) % previewVideos.length;
    playPreview();
  }, 4000);
}


  // iniciar ciclo
  playPreview();

  // 3) Click en miniatura → abrir modal
  thumbButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // parar el autoplay
      clearTimeout(previewTimer);
      previewVideos.forEach(v => {
        v.pause();
        v.currentTime = 0;
      });

      // marcar activa
      thumbButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // cargar y reproducir en modal
      const src = btn.dataset.videoUrl;
      modalVideo.querySelector('source').src = src;
      modalVideo.load();
      modalVideo.play();

      // mostrar modal
      modal.classList.add('open');
    });
  });

  // 4) Cerrar modal
  closeBtn.addEventListener('click', () => {
    modalVideo.pause();
    modal.classList.remove('open');
    // reanudar previews
    current = thumbButtons.findIndex(b => b.classList.contains('active'));
    if (current < 0) current = 0;
    playPreview();
  });
});

